import React, { useEffect, useState } from "react";
import { FormGroup, IconButton, Tooltip } from "@mui/material";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import CoreTextArea from "../../../app/core/components/CoreTextArea/CoreTextArea";
import { toast } from "react-toastify";
import { filterRoles, ROLE } from "../../../utils/constants/profiles";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";
import {
  useDeleteCommercialistaMutation,
  useSaveCommercialistaMutation,
} from "../../api/admin/gestisciCommercialistiApi";
import { useNavigate } from "react-router-dom";
import CoreSelectObjArr from "../../../app/core/components/CoreSelect/CoreSelectObjArr";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  adminStudioApi,
  useAddGroupAdminMutation,
  useGetGroupAdminIdQuery,
  useGetGroupStudioQuery,
  useRemoveGroupAdminMutation,
} from "../../api/admin/gestisciStudioApi";
import { useGetRolesQuery } from "../../api/admin/rolesApi";
import PersonRemoveRoundedIcon from "@mui/icons-material/PersonRemoveRounded";

const FormOperator = ({ operatorData, onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const role = useSelector((state) => state.app.role);
  const subRole = useSelector((state) => state.app.subRole);
  const adminId = useSelector((state) => state.app.adminId);
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    licenseCount: "",
    notes: "",
    subRole: "",
    adminProfileRoles: [],
  });
  const [showConfirmUserDialog, setShowConfirmUserDialog] = useState(false);
  const [showGroupInput, setShowGroupInput] = useState(false);
  const [isGroup, setIsGroup] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState();

  const { data: adminRoles } = useGetRolesQuery();

  const { data: dataGroup } = useGetGroupStudioQuery(adminId);
  const { data: groupAdmin } = useGetGroupAdminIdQuery(operatorData?.Data?.id, {
    skip: !operatorData?.Data?.id,
  });

  const filteredRoles = filterRoles(adminRoles?.Data, role, subRole);

  const OPERATOR_TYPES = filteredRoles?.map((type) => ({
    label: type.name,
    value: type.id,
    capabilities: type.capabilities,
  }));

  const GROUP_LIST = dataGroup?.Data.map((el) => ({
    label: el.name,
    value: el.id,
  }));

  const [saveCommercialista, { isLoading: isLoadingSave }] =
    useSaveCommercialistaMutation();
  const [deleteCommercialista, { isLoading: isLoadingDelete }] =
    useDeleteCommercialistaMutation();

  const [addGruopAdmin] = useAddGroupAdminMutation();
  const [removeGroupAdmin] = useRemoveGroupAdminMutation();

  useEffect(() => {
    if (operatorData && operatorData.Data) {
      setFormData({
        name: operatorData.Data.name,
        surname: operatorData.Data.surname,
        email: operatorData.Data.email,
        licenseCount: operatorData.Data.licenseCount,
        notes: operatorData.Data.notes || "",
        subRole: operatorData.Data.subRole,
        adminProfileRoles: [operatorData.Data.adminProfileRoles[0]?.roleId],
      });
    }
  }, [operatorData]);

  useEffect(() => {
    if (groupAdmin && groupAdmin?.Data && groupAdmin?.Data?.id) {
      setShowGroupInput(true);
      setSelectedGroup(groupAdmin.Data.id);
      setIsGroup(true);
    }
  }, [groupAdmin]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "adminProfileRoles") {
      // Trova il ruolo selezionato
      const selectedRole = OPERATOR_TYPES?.find((r) => r.value === value);

      // Se il ruolo ha capability 1003 => mostra nuovo input
      const hasCapability1003 = selectedRole?.capabilities?.some(
        (cap) => cap.description === ROLE.GROUP_ADMIN
      );
      setShowGroupInput(hasCapability1003);

      if (!hasCapability1003) {
        setSelectedGroup("");
      }

      setFormData((prevData) => ({
        ...prevData,
        [name]: [value],
      }));
      return;
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleChangeGroup = (e) => {
    setSelectedGroup(e.target.value);
  };

  const handleDelete = () => {
    setShowConfirmUserDialog(true);
  };

  const handleCloseDialod = () => {
    setShowConfirmUserDialog(false);
  };

  const handleConfermDialog = (id) => {
    const idToast = toast.loading(t("Deleting..."), {
      pauseOnFocusLoss: false,
      type: "info",
    });

    deleteCommercialista(id)
      .then((res) => {
        if (res.data.Result !== 1) {
          toast.update(idToast, {
            render: res.data.Exception || `${t("OperatorNotDeleted")}`,
            type: "error",
            autoClose: 1500,
            isLoading: false,
          });
          handleCloseDialod();
          if (role === ROLE.STUDIO) onClose();
          if (role === ROLE.ADMIN) navigate(-1);
          return;
        }

        toast.update(idToast, {
          render: `${t("OperatorDeleted")}`,
          type: "success",
          autoClose: 1500,
          isLoading: false,
        });
        handleCloseDialod();
        if (role === ROLE.STUDIO) onClose();
        if (role === ROLE.ADMIN) navigate(-1);
      })
      .catch(() => {
        toast.update(idToast, {
          render: `${t("OperatorNotDeleted")}`,
          type: "error",
          autoClose: 1500,
          isLoading: false,
        });
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const editData = {
      id: operatorData.Data.id,
      name: formData.name,
      surname: formData.surname,
      email: formData.email,
      licenseCount: formData.licenseCount,
      notes: formData.notes,
      adminProfileRoles: formData.adminProfileRoles,
    };

    const addAdminToGroup = {
      adminid: operatorData.Data.id,
      studioGroupId: selectedGroup,
    };

    if (showGroupInput && selectedGroup) {
      await addGruopAdmin(addAdminToGroup)
        .then((res) => {
          if (res.data.Exception) {
            toast.error(res.data.Exception);
          } else if (res.data.Data) {
            toast.success(`${t("GroupAdminSaved")}`);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }

    saveCommercialista(editData)
      .then((res) => {
        if (res.data.Exception) {
          toast.error(res.data.Exception);
        } else if (res.data.Data) {
          toast.success(`${t("OperatorUpdated")}`);
          dispatch(adminStudioApi.util.invalidateTags(["studios"]));
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const handleRemoveAdminGroup = () => {
    const addAdminToGroup = {
      adminid: operatorData.Data.id,
      studioGroupId: selectedGroup,
    };

    removeGroupAdmin(addAdminToGroup)
      .then((res) => {
        if (res.data.Exception) {
          toast.error(res.data.Exception);
        } else if (res.data.Data) {
          toast.success(`${t("GroupAdminSaved")}`);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
    window.location.reload();
  };

  return (
    <div className="flex flex-col w-full ">
      <h3>Dati</h3>
      <div className="flex space-x-10">
        <FormGroup className="w-full">
          <CoreInputField
            label={t("Name")}
            name="name"
            onChange={handleChange}
            value={formData.name}
          />
        </FormGroup>
        <FormGroup className="w-full">
          <CoreInputField
            label={t("Surname")}
            name="surname"
            onChange={handleChange}
            value={formData.surname}
          />
        </FormGroup>
      </div>

      <div className="flex space-x-10">
        <FormGroup className="w-full">
          <CoreInputField
            label="Email"
            name="email"
            onChange={handleChange}
            value={formData.email}
          />
        </FormGroup>
      </div>
      <div className="flex space-x-10">
        {/* <FormGroup className="w-full">
          <CoreInputField
            label={t("License")}
            name="licenseCount"
            onChange={handleChange}
            value={formData.licenseCount}
          />
        </FormGroup> */}
      </div>
      <div className="pt-8">
        <FormGroup className="w-full">
          <CoreSelectObjArr
            name="adminProfileRoles"
            label={t("OperatorType")}
            value={formData.adminProfileRoles}
            items={OPERATOR_TYPES}
            onChange={handleChange}
            isFull={true}
            className="w-full"
          />
        </FormGroup>
      </div>
      {showGroupInput && (
        <div className="flex items-center space-x-4">
          <FormGroup className="w-full py-5">
            <CoreSelectObjArr
              name="groupId"
              label={t("Group")}
              value={selectedGroup}
              items={GROUP_LIST}
              onChange={handleChangeGroup}
              isFull={true}
              className="w-full"
            />
          </FormGroup>
          {isGroup && (
            <Tooltip title={t("DeleteAdminGroup")}>
              <IconButton variant="outlined" onClick={handleRemoveAdminGroup}>
                <PersonRemoveRoundedIcon className={"fill-rose-600"} />
              </IconButton>
            </Tooltip>
          )}
        </div>
      )}

      <div className="flex flex-col py-7">
        <FormGroup className="w-full">
          <CoreTextArea
            label={t("Notes")}
            rows={5}
            name="notes"
            onChange={handleChange}
            value={formData.notes}
          />
        </FormGroup>
      </div>
      <div className="flex justify-around py-5">
        <CoreButton
          testo={t("Delete")}
          className="bg-red-700 btn-round border-red-700"
          onClick={handleDelete}
          disabled={isLoadingSave}
        />
        <CoreButton
          testo={isLoadingDelete ? t("Wait") : t("Save")}
          className="btn-round"
          onClick={handleSubmit}
          disabled={isLoadingSave}
        />
      </div>
      <CoreDialog
        open={showConfirmUserDialog}
        title={`${t("Delete")} ${t("operator")}`}
        content={`${t("OperatorDeletingConfirm")} ${operatorData?.Data?.name} ${
          operatorData?.Data?.surname
        }?`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={() => handleConfermDialog(operatorData.Data.id)}
        closeDialog={handleCloseDialod}
      />
    </div>
  );
};

export default FormOperator;
